<template>
  <footer class="app-footer">
    <small>© Zane Carter</small>
  </footer>
</template>

<script setup>
</script>

<style scoped>
.app-footer{
  border-top:1px solid #EEE;
  background:#fff;
  padding:.75rem 1rem;
  text-align:center;
  color:#6d6d6d;
}
</style>